var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 11.0002C13.5314 11.0002 15.5834 8.94813 15.5834 6.41683C15.5834 3.88552 13.5314 1.8335 11.0001 1.8335C8.46878 1.8335 6.41675 3.88552 6.41675 6.41683C6.41675 8.94813 8.46878 11.0002 11.0001 11.0002Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12573 20.1667C3.12573 16.6192 6.6549 13.75 10.9999 13.75C11.8799 13.75 12.7324 13.8692 13.5299 14.0892",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 16.5002C20.1666 16.7935 20.1299 17.0777 20.0566 17.3527C19.9741 17.7193 19.8274 18.0768 19.6349 18.3885C19.0024 19.4518 17.8383 20.1668 16.4999 20.1668C15.5558 20.1668 14.7032 19.8093 14.0616 19.2226C13.7866 18.9843 13.5482 18.7002 13.3649 18.3885C13.0257 17.8385 12.8333 17.1877 12.8333 16.5002C12.8333 15.5102 13.2274 14.6027 13.8691 13.9427C14.5383 13.2552 15.4733 12.8335 16.4999 12.8335C17.5816 12.8335 18.5624 13.301 19.2224 14.0527C19.8091 14.7035 20.1666 15.5652 20.1666 16.5002Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8659 16.4819H15.1343",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.1436V17.8844",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.dc14ebe1a24dd38ba3220cf96413a750.svg";
export { ForwardRef as ReactComponent };